import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import {
  PersistQueryClientProvider,
  persistQueryClient,
} from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
// import { Integrations } from '@sentry/tracing';
// import * as Sentry from '@sentry/react';
import MessageDisplayer from 'Common/Components/MessageDisplayer';
// import { NewVersionNotification } from 'Common/notifications';
import OwnIntlProvider from 'utils/OwnIntlProvider';
import theme, { GlobalStyle } from 'assets/theme';
import Router from 'routers/Router';
import AntdConfigProvider from 'utils/AntdConfigProvider';
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import globalConfig from './config';

// const { IN_PRODUCTION } = globalConfig;

const MOUNT_NODE = document.getElementById('root');

// Sentry.init({
//   dsn: 'https://b1950b669c954ef7ad417d88cb9a256d@o82653.ingest.sentry.io/5525195',
//   integrations: [new Integrations.BrowserTracing()],

//   // This should be a float between 0.0 and 1.0 (inclusive) and represents the percentage chance that any given
//   // transaction will be sent to Sentry. (0.0 is a 0% chance, effectively disabling tracing, and 1.0 is a 100% chance,
//   // meaning all transactions will be sent.)
//   tracesSampleRate: 1.0,
//   environment: IN_PRODUCTION ? 'production' : 'staging',
// });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
});

const persister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister,
});

Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 35 }} />);
const root = createRoot(MOUNT_NODE);
root.render(
  <PersistQueryClientProvider
    client={queryClient}
    persistOptions={{ persister }}
  >
    <OwnIntlProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <AntdConfigProvider>
          <Router />
          <MessageDisplayer />
        </AntdConfigProvider>
      </ThemeProvider>
    </OwnIntlProvider>
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-left" />
  </PersistQueryClientProvider>
);

const w: any = window;
w.persistor = persister;

// serviceWorkerRegistration.register({
//   onUpdate: async (registration: ServiceWorkerRegistration) => {
//     // We want to run this code only if we detect a new service worker is
//     // waiting to be activated.
//     // Details about it: https://developers.google.com/web/fundamentals/primers/service-workers/lifecycle
//     if (registration && registration.waiting) {
//       await registration.unregister();
//       // Makes Workbox call skipWaiting()
//       registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//       // Once the service worker is unregistered, we can reload the page to let
//       // the browser download a fresh copy of our app (invalidating the cache)
//       // window.location.reload();
//       // or simply display a notification to the user, and ask him to refresh the page in the most appropriate moment
//       NewVersionNotification.next();
//     }
//   },
// });
